import React from 'react';
import './App.css';
import TaskManager  from "./container/TaskManager/index";
function App() {
  return (
    <div className="App">
      <TaskManager/>
    </div>
  );
}

export default App;
